

































import { defineComponent, computed, Ref, ref, onMounted, ComputedRef, watch, onUnmounted } from "@vue/composition-api";
import axios from 'axios';
// Store
import { Endpoints } from '@/ts/store/Constants';
import { Mutations } from '@/ts/store/modules/Channels/constants';

// types
import { Message } from '@/views/Admin/Channels/channelTypes';
import { mapResponseToMessage } from '@/views/Admin/Channels/mappingUtil';


// components
import ChannelMessage from '@/views/Admin/Channels/components/ChannelMessage.vue';
import DeletedMessage from '@/views/Admin/Channels/components/DeletedMessage.vue';
import SubTitle from '@/components/NEW-STRUCTURE/desktop/Admin/titles/SubTitle.vue';

export default defineComponent({
    components: {
        ChannelMessage,
        DeletedMessage,
        SubTitle,
    },
    props: {
        channelId: String,
    },
    setup(props, { root, emit }) {
        const store = root.$store;

        const blockedMessages : Ref<Message[]> = ref([]);

        const channelTabs: ComputedRef<any> = computed(() => {
            return store.getters['Channels/getChannelsTabs'];
        });

        const handleGoBack = () => {
            const { CHANNEL_INFO } = channelTabs.value;
            emit('changeManagementTab', CHANNEL_INFO);
        }

        const handleMessageDeleteState = () => {
            fetchBlockedMessages(0);
        }

        const userId: ComputedRef<number> = computed(() => {
            return store.getters['User/getUserId'];
        });

        const refetchMessages: ComputedRef<boolean> = computed(() => {
            return store.getters['Channels/getRefetchMessages'];
        });

        // TODO change endpoint to get blocked messages
        const fetchBlockedMessages = async (page: number): Promise<Message[]> => {
            if (props.channelId) {
                const response = await axios.get(Endpoints.Admin.Channels.CHANNEL_REPORTED_MESSAGES(props.channelId), {
                    params: {
                        page,
                    },
                });

                return response.data.data
                    .filter((message) => message.body !== null)
                    .map((message) => {
                        return mapResponseToMessage(message);
                    });
            } else {
                return null;
            }
        };

        watch(() => props.channelId, async (newValue, oldValue) => {
            blockedMessages.value = [];
            if (!oldValue || (newValue && (newValue !== oldValue))) {
                blockedMessages.value = await fetchBlockedMessages(0);
            }
        });

        watch(() => refetchMessages.value, async (newValue, oldValue) => {
            if (newValue) {
                blockedMessages.value = await fetchBlockedMessages(0);
                store.commit(Mutations.SET_FETCH_MESSAGES, false);
            }
        });

        onMounted(async() => {
            blockedMessages.value = await fetchBlockedMessages(0);
        });

        onUnmounted(() => {
            blockedMessages.value = [];
        });

        return {
            blockedMessages,
            handleGoBack,
            handleMessageDeleteState,
            userId,
            refetchMessages,
        };
    }
});
